jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   // $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   // });
// Tamam ".money" class wale elements ko select karein
document.querySelectorAll('.cartFusion_fbt_item .money').forEach(span => {
    // Agar text "PKR 0" hai (spaces hata kar check karega)
    if (span.textContent.trim() === 'PKR 0') {
        span.style.display = 'none'; // Color red kar do
        // Aap chahein to style direct dene ki bajaye class bhi add kar sakte hain:
        // span.classList.add('zero-price');
    }
});

$( document ).on( "variant:changed", function( evt ) {
// document.querySelector(.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]).selected = true;
const cartFusionVariant = document.querySelector(`.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]`);

if (cartFusionVariant) {
  cartFusionVariant.selected = true;

  if (cartFusionVariant.disabled === true) {
    // console.log('soldout')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'none';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'none';
    document.querySelector('.soldOutButton').removeAttribute('hidden');
  } else {
    // console.log('instock')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'block';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'block';
    document.querySelector('.soldOutButton').setAttribute('hidden', '');
  }
}
});

document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
  ele.addEventListener("input", function () {
    if (this.value < 0) {
        this.value = 0;
    }
  });
});
  $(document).on("variant:changed", function (evt) {
    // console.log(evt.currentVariant.title);
    if (evt.currentVariant.title.includes('Customised')) {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.removeAttribute("disabled");
        });
    } else {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.setAttribute("disabled", "disabled");
        });
    };
  });


  

});